import { render, staticRenderFns } from "./floating_loader.vue?vue&type=template&id=0796bdf0&scoped=true"
import script from "./floating_loader.vue?vue&type=script&lang=js"
export * from "./floating_loader.vue?vue&type=script&lang=js"
import style0 from "./floating_loader.vue?vue&type=style&index=0&id=0796bdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796bdf0",
  null
  
)

export default component.exports